
import { getLocale, t } from '@nextcloud/l10n'
import NcButton from '@nextcloud/vue/components/NcButton'
import NcPopover from '@nextcloud/vue/components/NcPopover'
import NcSelect from '@nextcloud/vue/components/NcSelect'
import IconBackspaceOutline from 'vue-material-design-icons/BackspaceOutline.vue'
import IconDialpad from 'vue-material-design-icons/Dialpad.vue'
import { regionCodes } from '../../regionCodes.js'

const allowedKeys = /^[0-9+\-()*#\s]+$/

const buttonsDigits = [
	{ value: '1', label: '1' },
	{ value: '2', label: '2' },
	{ value: '3', label: '3' },
	{ value: '4', label: '4' },
	{ value: '5', label: '5' },
	{ value: '6', label: '6' },
	{ value: '7', label: '7' },
	{ value: '8', label: '8' },
	{ value: '9', label: '9' },
]

const buttonsNumberOption = [
	{ value: '+', label: '+' },
	{ value: '0', label: '0' },
]

const buttonsDialOption = [
	{ value: '*', label: '*' },
	{ value: '0', label: '0' },
	{ value: '#', label: '#' },
]

export default {
	name: 'DialpadPanel',

	components: {
		IconBackspaceOutline,
		IconDialpad,
		NcButton,
		NcPopover,
		NcSelect,
	},

	props: {
		/**
		 * The conversation token of the message to be replied to.
		 */
		token: {
			type: String,
			default: '',
		},

		/**
		 * The conversation token of the message to be replied to.
		 */
		value: {
			type: String,
			default: '',
		},

		/**
		 * The CSS selector to attach popover to.
		 */
		container: {
			type: String,
			default: '#dial-popover',
		},

		/**
		 * Whether special symbols * and # will be used to dial
		 */
		dialing: {
			type: Boolean,
			default: false,
		},

		disabled: {
			type: Boolean,
			default: false,
		},
	},

	emits: ['dial:type', 'update:value', 'submit'],

	setup(props) {
		const options = Object.values(regionCodes).map((region) => ({ ...region, dial_and_name: region.dial_code + ' ' + region.name }))

		const buttons = props.dialing
			? buttonsDigits.concat(buttonsDialOption)
			: buttonsDigits.concat(buttonsNumberOption)

		return {
			buttons,
			options,
		}
	},

	data() {
		return {
			region: null,
		}
	},

	methods: {
		t,
		handlePad(value) {
			if (this.dialing) {
				this.$emit('dial:type', value)
			} else {
				this.$emit('update:value', this.value + value)
			}
		},

		dialCode(value) {
			this.$emit('update:value', value.dial_code)

			this.$nextTick(() => {
				this.$refs.panel?.focus()
			})
		},

		prefillCode() {
			if (this.dialing) {
				return
			}
			// Attempt to parse user's defined locale and return dial code based on it
			const locale = getLocale().toUpperCase()
			this.region = regionCodes[locale]
				|| regionCodes[locale.split('_').pop()]
				|| regionCodes[locale.split('_').shift()]

			// Pre-fill input if the value
			if (this.region && this.value === '') {
				this.dialCode(this.region)
			}
		},

		handleKeyDown(event) {
			if (!this.dialing && this.$refs.regionSelect.$el.contains(event.target)) {
				// Ignore events from NcSelect
				return
			}
			if (allowedKeys.test(event.key)) {
				this.handlePad(event.key)
			} else if (event.key === 'Backspace') {
				this.handleBackspace()
			} else if (event.key === 'Enter') {
				this.$emit('submit', event)
				this.$refs.popover.$refs.popover.hide()
			}
		},

		handleBackspace() {
			this.$emit('update:value', this.value.slice(0, -1))
		},
	},
}
